import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterPipe, TruncatePipe, DonwloadPipe, TitleCasePipe, AmInitDirective } from './../Helper';



@NgModule({
  declarations: [
    FilterPipe, TruncatePipe, DonwloadPipe,TitleCasePipe,AmInitDirective
      
  ],
  entryComponents:[],
  imports: [
    CommonModule
  ],
  exports:[
    FilterPipe, TruncatePipe, DonwloadPipe,TitleCasePipe,AmInitDirective
  ]
})
export class SharedModule { }
